import { fromJS } from 'immutable';

import Constants from '../../constants';

const { VendorAttribution } = Constants;
const initialState = fromJS({
  loading: false,
  error: null,
  vendor: {},
});

const vendorAttributesReducer = (state = initialState, action) => {
  const { error, vendor } = action;

  switch (action.type) {
    case VendorAttribution.CREATE_VENDOR_ATTRIBUTES:
      return state.set('loading', true).set('error', null);
    case VendorAttribution.CREATE_VENDOR_ATTRIBUTES_ERROR:
      return state.set('loading', false).set('error', error);
    case VendorAttribution.CREATE_VENDOR_ATTRIBUTES_SUCCESS:
      return state.set('loading', false).set('error', null);
    case VendorAttribution.UPDATE_VENDOR_ATTRIBUTES:
      return state.set('loading', true).set('error', null);
    case VendorAttribution.UPDATE_VENDOR_ATTRIBUTES_ERROR:
      return state.set('loading', false).set('error', error);
    case VendorAttribution.UPDATE_VENDOR_ATTRIBUTES_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .set('vendor', fromJS(vendor));
    default:
      return state;
  }
};

export default vendorAttributesReducer;
